import { render, staticRenderFns } from "./ChoppingMealDescription.vue?vue&type=template&id=4469ff8c&"
import script from "./ChoppingMealDescription.vue?vue&type=script&lang=js&"
export * from "./ChoppingMealDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports